import * as types from 'actions/ActionTypes';

const initalState = {
	broken1: false,
};

const decos = (state = initalState, action) => {
	switch (action.type) {
		case types.DECOSVIEW:
			return Object.assign({}, state, { broken1: action.broken1 });
		default:
			return state;
	}
};

export default decos;
